export var filterBehaviourOptions;
(function (filterBehaviourOptions) {
    filterBehaviourOptions[filterBehaviourOptions["and"] = 1] = "and";
    filterBehaviourOptions[filterBehaviourOptions["or"] = 2] = "or";
})(filterBehaviourOptions || (filterBehaviourOptions = {}));
